import {
  CheckCircle,
  type Icon,
  Info,
  WarningCircle,
  X,
  XCircle,
} from "@phosphor-icons/react";
import { cva } from "class-variance-authority";
import { ToastContainer as ReactToastifyContainer } from "react-toastify";

const toastVariants = cva(
  "flex mb-4 gap-x-1.5 items-center rounded-2xl bg-white p-1.5 text-button-sm text-black-950 last:mb-0 lg:max-w-80",
  {
    variants: {
      type: {
        default:
          "shadow-[0_0_0_3px_#F4F4F4,0_0_0_4px_#E5E7EB,0_6px_13.8px_2px_rgba(17,24,39,0.10)]",
        success:
          "shadow-[0_0_0_3px_#F4F4F4,0_0_0_4px_#4ADE80,0_6px_13.8px_2px_rgba(17,24,39,0.10)]",
        error:
          "shadow-[0_0_0_3px_#F4F4F4,0_0_0_4px_#FA5C5C,0_6px_13.8px_2px_rgba(17,24,39,0.10)]",
        warning:
          "shadow-[0_0_0_3px_#F4F4F4,0_0_0_4px_#FFC120,0_6px_13.8px_2px_rgba(17,24,39,0.10)]",
        info: "shadow-[0_0_0_3px_#F4F4F4,0_0_0_4px_#E5E7EB,0_6px_13.8px_2px_rgba(17,24,39,0.10)]",
      },
    },
  },
);

type ToastVariant = "default" | "success" | "error" | "warning" | "info";

const icon: Record<ToastVariant, Icon> = {
  success: CheckCircle,
  error: XCircle,
  warning: WarningCircle,
  default: Info,
  info: Info,
};

export default function ToastContainer() {
  return (
    <ReactToastifyContainer
      className="max-lg:p-4 [&_.Toastify\\_\\_toast-icon]:bg-black-100 [&_.Toastify\\_\\_toast-icon]:size-6 [&_.Toastify\\_\\_toast-icon]:flex [&_.Toastify\\_\\_toast-icon]:items-center [&_.Toastify\\_\\_toast-icon]:justify-center [&_.Toastify\\_\\_toast-icon]:rounded-full [&_.Toastify\\_\\_toast-icon]:mr-0"
      autoClose={3000}
      hideProgressBar
      icon={({ type }) => {
        const Icon = icon[type];

        return <Icon weight="fill" />;
      }}
      closeButton={({ closeToast }) => (
        <button
          onClick={closeToast}
          type="button"
          aria-label="close toast"
          className="size-8 ml-auto inline-flex items-center justify-center"
        >
          <X size={16} className="text-black-700" />
        </button>
      )}
      toastClassName={({ type }) => toastVariants({ type })}
    />
  );
}
ToastContainer.defaultName = "ToastContainer";
